<script>
    import ButtonCircular from '../ButtonCircular.svelte'
    import CircularIndicator from '../CircularIndicator.svelte'
    import * as Fx from '../../globals/Fx'
    import { createEventDispatcher } from "svelte";
    
    const dispatch = createEventDispatcher();
    
    export let LIQUIDADOS = null
    
    let w
    let h
    
    const _handleClickEvent = (OPCION) => {
        dispatch("click",{opcion : OPCION})
    }

</script>


<div class="option-container d-flex flex-column align-items-center justify-content-center text-center mx-1 position-relative" style="max-width: 300px;">
    <div style="width: 200px;height:200px;" bind:clientWidth={w} bind:clientHeight={h}>
        {#if LIQUIDADOS }
            <CircularIndicator porc={LIQUIDADOS.porc_con_csmo_energia} {w} {h} lineWidth={20} label="Consumos">
                <div class="buttons">
                    <ButtonCircular
                        {w} {h} n={1} title={"Cargar Consumos"} on:click={() =>_handleClickEvent("CSMO-UPLOAD")}
                    >
                        <ion-icon name="arrow-up-outline"></ion-icon>
                    </ButtonCircular>
                    <ButtonCircular
                        {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("CSMO-LISTADO")}
                    >
                        <ion-icon name="list-outline"></ion-icon>
                    </ButtonCircular>
                </div>
            </CircularIndicator>
        {:else}
            <CircularIndicator porc={0} {w} {h} lineWidth={20} label="Consumos">
                <div class="buttons">
                    <ButtonCircular
                        {w} {h} n={1} title={"Cargar Consumos"} on:click={() =>_handleClickEvent("CSMO-UPLOAD")}
                    >
                        <ion-icon name="arrow-up-outline"></ion-icon>
                    </ButtonCircular>
                    <ButtonCircular
                        {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("CSMO-LISTADO")}
                    >
                        <ion-icon name="list-outline"></ion-icon>
                    </ButtonCircular>
                </div>
            </CircularIndicator>
            
        {/if}
    </div>
    <span class="title-desc">Consumos</span>
    <p style="color:#00000055">En este periodo se encuentran cargados <strong>{LIQUIDADOS ? LIQUIDADOS.cant_csmo_energia : 0}</strong> consumos de un total de <strong>{LIQUIDADOS ? LIQUIDADOS.cant_total : 0}</strong> suscriptores disponibles. El total de consumo cargado es de <strong>{LIQUIDADOS ? Fx.formatter.format(LIQUIDADOS.total_csmo_energia).cop() : 0}</strong> </p>
</div>

<style>
    .title-desc {
        margin-top: 10px;
        color: #34495e;
        font-size: 1.5em;
        font-weight: bold;
    }

    .buttons {
        opacity: 0;
        transition: opacity 500ms;
    }
    
    .option-container:hover .buttons {
        display: flex;
        opacity: 1;
    }

    ion-icon  {
        pointer-events: none;
    }
    
</style>